import React from 'react';
import { Button } from 'antd';

const FilterButton = ({ 
    children, 
    onClick, 
    type = 'default',
    size = 'middle',
    ...props 
}) => {
    return (
        <Button
            type={type}
            size={size}
            onClick={onClick}
            className="filter-button"
            {...props}
        >
            {children}
        </Button>
    );
};

export default FilterButton;
